import { render, staticRenderFns } from "./DetailReportWork.vue?vue&type=template&id=05e260c5&"
import script from "./DetailReportWork.vue?vue&type=script&lang=js&"
export * from "./DetailReportWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports